// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  matchId: __t.string().name("match_id"),
  sourceUnitId: __t.string().name("source_unit_id"),
  targetUnitId: __t.string().name("target_unit_id"),
  damage: __t.f64(),
  x: __t.f64(),
  y: __t.f64(),
  vx: __t.f64(),
  vy: __t.f64(),
  ticksAlive: __t.u32().name("ticks_alive"),
  maxTicks: __t.u32().name("max_ticks"),
  teamIndex: __t.u32().name("team_index"),
  projectileType: __t.string().name("projectile_type"),
  flightTicks: __t.u32().name("flight_ticks"),
});
